import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import {
    BillingEvents,
    authRoutines,
    getIsCloudPortal,
    routes,
    selectIsPendingOwner,
    selectSsoToken,
    useToastListener,
} from '@cloud/shared';
import { Cookies } from 'ovpn-ui-toolkit';

import { Navigation } from './features/navigation';
import { Notification } from './features/notifications';
import { ToastContainer } from './features/toast';
import { useBillingBannerOffset, useHelpWidget, useMfEvents, useSetupCssVariables } from './hooks';

const AQAModeFlags = Cookies.getCookie('__ENABLE_AQA_MODE__');

const hideNotificationBanner = AQAModeFlags?.includes('-notification-banner');

const mfDispatchedActions = [
    // dispatchedActions:
    authRoutines.setAuthToken.TRIGGER,
    authRoutines.authorized.SUCCESS,
    authRoutines.unauthorized.TRIGGER,
    authRoutines.refreshToken.SUCCESS,
    BillingEvents.BILLING_OPEN_MODAL,
];

function App() {
    useHelpWidget();
    useSetupCssVariables();
    useBillingBannerOffset();
    useToastListener(toast);
    useMfEvents('cloud-nav', mfDispatchedActions);

    const pathname = window.location.pathname;

    const ssoToken = useSelector(selectSsoToken);
    const isPendingOwner = useSelector(selectIsPendingOwner);
    const isCloudPortal = getIsCloudPortal(window.location.href);
    const isWizardPortal =
        pathname.startsWith(routes.wizard.index) || pathname === routes.selectPlan;

    if (ssoToken === undefined || isPendingOwner || isCloudPortal) {
        return null;
    }

    if (isWizardPortal) {
        return <ToastContainer />;
    }

    return (
        <>
            <Navigation />
            {!hideNotificationBanner && <Notification />}
            <ToastContainer />
        </>
    );
}

export default App;
